module.exports = __webpack_public_path__ + "img/vertical_4_7_1.f3d7ebc8.png";